import { AuthContext } from '../../contexts/AuthContext/definition'
import { ImpersonationContext } from '../../contexts/ImpersonationContext/definition'

import { useContext, useEffect, useState } from 'react'

import './index.css'
import styles from './index.module.css'
import {
  FILE_STATUSES,
  getFiles,
  MyFilesData,
  RelativeMonth,
} from '../../lib/api/moduleManager/getFiles'
import FilterBar from './components/FilterBar'
import FileTotalsCard from './components/FileTotalsCard'
import ClawbackBreakdownCard from './components/ClawbackBreakdownCard'
import FilesTableCard from './components/FilesTableCard'

export default function MyFilesPage() {
  const { moduleManagerToken } = useContext(AuthContext)
  const { impersonatedUserEmail, impersonatedUserId, impersonatedUserToken } =
    useContext(ImpersonationContext)

  console.log(
    `MyFiles API Impersonation user: ${impersonatedUserEmail} (${impersonatedUserId})`,
  )

  const userID = localStorage.getItem('TD-user_ID')

  const [data, setData] = useState<MyFilesData | null>(null)
  const [loading, setLoading] = useState(false)
  const [month, setMonth] = useState<RelativeMonth>('Current Month')
  const [statusFilter, setStatusFilter] = useState<string[]>([])

  useEffect(() => {
    setLoading(true)
    getFiles(
      impersonatedUserToken || moduleManagerToken,
      impersonatedUserId || userID,
      { relativeMonth: month }, // add status filter here once BE is updated
    )
      .then((r) => {
        setData(r)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [
    month,
    moduleManagerToken,
    impersonatedUserEmail,
    impersonatedUserToken,
    impersonatedUserId,
    userID,
  ])

  const mainHandle = document.querySelector('main')
  if (mainHandle) {
    mainHandle.style.backgroundColor = '#0e101c'
    mainHandle.style.margin = '0'
  }

  return (
    <div className={styles.page}>
      <FilterBar
        agentName={data?.name ?? ''}
        month={month}
        onMonthChange={(value) => setMonth(value as RelativeMonth)}
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        allStatuses={FILE_STATUSES}
      />

      <div className={styles.topRow}>
        <FileTotalsCard rows={data?.file_totals ?? []} loading={loading} />
        <ClawbackBreakdownCard
          rows={data?.clawback_breakdowns ?? []}
          loading={loading}
        />
      </div>

      <FilesTableCard
        rows={data?.files ?? []}
        statusFilter={statusFilter}
        loading={loading}
      />
    </div>
  )
}
